import axios from "axios";

import url from "@/config/url";

export default {
  getLink() {
    // return axios(`${url.streams.CRUD}/create`);

    return new Promise((res, _) =>
      res({ data: { 
        token_shared: "link.to.stream.video",
        link_hls: "link_hls.to.stream",
        link_rtmp: "rtmp.link.to.stream"
      } })
    );
  },

  updateOnStopOfStream(id, data) {
    return axios.post(`${url.streams.updateOnStopOfStream}/${id}`, data);
  },

  storeStream(data) {
    // return axios({
    //   method: "post",
    //   url: url.streams.CRUD,
    //   data
    // });
    return axios("/moks/streams.json").then(res => ({ data: res.data.data[0] }));
  },

  updateStream(data, id) {
    return axios({
      method: "PATCH",
      url: `${url.streams.CRUD}/${id}`,
      data
    });
  },

  removeStream(id) {
    return axios({
      method: "DELETE",
      url: `${url.streams.CRUD}/${id}`
    });
  },

  getStream(id) {
    // return axios(`${url.streams.CRUD}/${id}`);

    return axios("/moks/streams.json");
  },

  getSharedStream(key) {
    // return axios(`${url.streams.shared}/${key}`);

    return axios("/moks/streams.json");
  },

  updateStat(id) {
    return axios(`${url.streams.updateStat}/${id}`);
  },

  getStreams(params) {
    // return axios({
    //   method: "get",
    //   url: url.streams.CRUD,
    //   params
    // });

    return axios("/moks/streams.json");
  },

  toggleLikeStream(id) {
    // return axios(`${url.streams.likes}/${id}`);


    // eslint-disable-next-line no-unreachable
    return new Promise((res, _) => res({ data: [{}] }));
  }
};
